import { DynamicIcon } from '@/components/ui/icons/dynamic-icon';
import { AgentMark } from '@/containers/agents/agent-mark.component';
import { ChatTabIcon } from './chat-tab-icon.component';
import type { TabsNavItem } from './use-tabs-nav.hook';

/**
 * A pin's mark: the page's icon, the agent's mark, or the chat's. A page's
 * icon is filled while it is selected.
 */
export function PinIcon({
  item,
  size,
  filled = false,
}: {
  item: TabsNavItem;
  size: number;
  filled?: boolean;
}) {
  if (item.chat) return <ChatTabIcon tab={item.chat} size={size} />;
  if (item.agentId) return <AgentMark agentId={item.agentId} size={size} />;
  return (
    <DynamicIcon
      name={item.iconName}
      size={size}
      weight={filled ? 'fill' : undefined}
    />
  );
}
